import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Container, ITagProps, Spinner, Text } from 'telia-front-react';
import RoamingStore from '../stores/RoamingStore';
import SegmentStore from '../stores/SegmentStore';
import RoamingCountryCard from './countrycard/RoamingCountryCard';
import RoamingOperators from './operators/RoamingOperators';
import SpecialAndEmergencyInformation from './specialnumbers/SpecialAndEmergencyInformation';

export interface RoamingResultsProps {
  countriesWithoutAutoDayPackage?: string[];
  dailyPackageTag?: ITagProps;
  weeklyPackageTag?: ITagProps;
  monthlyPackageTag?: ITagProps;
  roamingStore?: RoamingStore;
  segmentStore?: SegmentStore;
}

@observer
class RoamingResults extends React.Component<RoamingResultsProps> {
  public componentDidMount() {
    this.props.roamingStore.subscribe(this.props.segmentStore.currentSegment);
    this.props.roamingStore.setDailyPackageTag(this.props.dailyPackageTag);
    this.props.roamingStore.setWeeklyPackageTag(this.props.weeklyPackageTag);
    this.props.roamingStore.setMonthlyPackageTag(this.props.monthlyPackageTag);
  }

  public componentWillUnmount() {
    this.props.roamingStore.unsubscribe();
  }

  public render() {
    const { roamingStore, segmentStore, countriesWithoutAutoDayPackage } = this.props;
    const segment = segmentStore.currentSegment;
    if (roamingStore.isCountriesFetching()) {
      return <Spinner />;
    }
    return (
      <Container>
        <div id="roaming-result">
          <Text>
            <RoamingCountryCard segment={segment} countriesWithoutAutoDayPackage={countriesWithoutAutoDayPackage} />
            <RoamingOperators segment={segment} />
            <SpecialAndEmergencyInformation />
          </Text>
        </div>
      </Container>
    );
  }
}

export default inject('roamingStore', 'segmentStore')(RoamingResults);
